/* eslint-disable sonarjs/cognitive-complexity, react-hooks/exhaustive-deps, react/forbid-component-props */
import { faMapMarkerAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import dayjs from 'dayjs';
import isEmpty from 'lodash/isEmpty';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useState, useContext, useEffect } from 'react';
import ReactCookies from 'react-cookies';
import { useDispatch } from 'react-redux';
import { Element, scroller } from 'react-scroll';
import { DEFAULT_LOCATION } from '../../../brands/default/config';
import {
  COOKIES,
  EMAIL_INPUT_SCROLL_TO_ID,
  LIGHTBOX_APPEARED,
  MODALS,
  SIGN_UP_WITH_GOOGLE,
  SUBSCRIBER_TEST_IDS,
} from '../../../brands/default/constants';
import { SUBSCRIBER } from '../../../brands/default/content/components/forms';
import { LINK_LOGIN } from '../../../brands/default/links';
import commonCookiesOptions from '../../../helpers/commonCookiesOptions';
import {
  removeCookie,
  setCookie,
  setPostLoginUrl,
  setSubscribedBrandWinCookie,
} from '../../../helpers/cookieSetter';
import ErrorTrackingService from '../../../helpers/errorTrackingService';
import { isMobileViewport, useScreenBreakpoint } from '../../../helpers/screen';
import { redirectToURL, parseWowcherPath } from '../../../helpers/url';
import { validateEmail } from '../../../helpers/validations';
import ThemeContext from '../../../providers/ThemeProvider';
import { setLocation } from '../../../redux/actions/locations';
import Icon from '../../Icon';
import Message from '../../_generic/Message';
import { sendBotAlert } from '../../_generic/axiosSplunk/axiosSplunk';
import BareSelect from '../../_generic/form/BareSelect';
import Spinner from '../../_generic/spinner/Spinner';
import TextDevider from '../../_generic/textDevider/TextDevider';
import useToast from '../../_generic/toast/UseToast';
import HeaderLogo from '../../header/HeaderLogo';
import LoginGoogle from '../../mediaButtons/GoogleButton';
import { getSubscriberStyle } from './Subscriber.style';
import {
  trackEmailEvent,
  setAxiosConfig,
  redirectToWPSUrl,
  redirectToLocationPage,
  checkKickbox,
} from './Subscriber.util';
import { SubscriberButtons } from './SubscriberButtons';
import { Input, Button } from './components';

export const Subscriber = ({
  isLightBox = false,
  isBadConnection = false,
  setShowModal = () => {},
  showCloseIcon = false,
  list,
  subTitle,
  defaultLocation,
  buttonText,
  redirectUrl = '',
  isLocation = false,
  isAuthenticated = false,
}) => {
  const [showError, setShowError] = useState(false);
  const [showKickboxError, setShowKickboxError] = useState(false);
  const [fieldonfocus, setOnFocus] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const toast = useToast();
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [botField, setBotField] = useState('');
  const router = useRouter();
  const userLocationCookie = ReactCookies.load(COOKIES.location);

  const { details } = parseWowcherPath(router.asPath);
  const urlHasLocationLightbox = isLocation && isLightBox;
  const breakpoint = useScreenBreakpoint();

  const [isMobile, setIsMobile] = useState(false);
  const [suggestedMail, setSuggestedMail] = useState('');

  useEffect(() => {
    setIsMobile(isMobileViewport());
  }, [breakpoint]);

  const getSelectedLocation = () => {
    if (details.urlHasLocation || urlHasLocationLightbox) {
      return defaultLocation;
    } else {
      if (userLocationCookie?.shortName) {
        return userLocationCookie?.shortName;
      }

      if (defaultLocation) {
        return defaultLocation;
      }

      return DEFAULT_LOCATION.shortName;
    }
  };

  const handleCloseButton = () => {
    setShowModal(false);
    localStorage.setItem(LIGHTBOX_APPEARED, JSON.stringify('exists'));

    // If the brand is not wowcher and brandCookie is not present
    const brandCookie = ReactCookies.load(COOKIES.brandCookie);
    if (
      !brandCookie &&
      (process.env.NEXT_PUBLIC_SITE !== 'wowcher' ||
        process.env.NEXT_PUBLIC_SITE !== 'fivepm')
    ) {
      setCookie({
        key: COOKIES.brandCookie,
        value: 'bypass_temp',
      });
    }
    if (isBadConnection) {
      const cookieExpire = dayjs().add(365, 'days').toISOString();

      ReactCookies.save(COOKIES.lightboxClosed, 'true', {
        ...commonCookiesOptions,
        expires: new Date(cookieExpire),
      });
    }
  };
  useEffect(() => {
    const close = (event) => {
      if (event.keyCode === 27 || event.key === 'Escape') {
        handleCloseButton();
      }
    };
    window.addEventListener('keydown', close, true);
  }, []);
  const [locationAux, setSelectLocation] = useState(getSelectedLocation());

  const onChangeAction = (value) => {
    setSelectLocation(value);
  };

  useEffect(() => {
    if (ReactCookies.load(COOKIES.lightboxClosed)) {
      ReactCookies.remove(COOKIES.lightboxClosed, {
        domain: `.${process.env.NEXT_PUBLIC_DOMAIN_NAME}`,
        path: '/',
      });
    }
  }, []);

  const theme = useContext(ThemeContext);
  const {
    SUBMIT_BUTTON,
    GOOGLE_BUTTON,
    SUBTITLE_TEXT,
    ERROR_TEXT,
    LOCATION_SELECT,
  } = SUBSCRIBER_TEST_IDS;

  const updatedList = list.map((element) => ({
    name: element.name,
    value: element.shortName,
  }));

  const goToLogin = () => {
    setPostLoginUrl(router.asPath);
    redirectToURL(LINK_LOGIN, router);
  };

  const setNewUserLocation = () => {
    const newLocation = list.find((locationObject) => {
      if (locationObject.shortName === locationAux) {
        return locationObject;
      }

      return null;
    });

    dispatch(setLocation(newLocation, true));
  };

  const handleCTCookie = (customerToken) => {
    if (!ReactCookies.load(COOKIES.customerToken)) {
      const expires = new Date();
      expires.setDate(expires.getDate() + 365);

      ReactCookies.save(COOKIES.customerToken, customerToken, {
        ...commonCookiesOptions,
        expires,
      });
    }
  };

  const handleOnSubscribed = (token) => {
    // BRAND-win (wowcher-win or livingsocial-win)
    setSubscribedBrandWinCookie();
    // Handle CT cookie
    handleCTCookie(token);
    setNewUserLocation();
  };

  const notifyError = (message) => {
    toast.addToast(message, 'toast-error');
  };

  const subscribeCall = async (userEmail, selectedLocation) => {
    try {
      setShowSpinner(true);
      const response = await setAxiosConfig(userEmail, selectedLocation);

      if (response?.data) {
        const { newEmail, status, token, message } = response.data;
        setShowSpinner(false);
        trackEmailEvent(newEmail);
        if (ReactCookies.load(COOKIES.userEmail)) {
          removeCookie(COOKIES.userEmail);
        }
        setCookie({
          expire: 365,
          key: COOKIES.userEmail,
          value: userEmail,
        });

        if (status === 'success') {
          handleOnSubscribed(token);
          if (!isEmpty(redirectUrl)) {
            redirectToWPSUrl(redirectUrl, selectedLocation, router);
          }
          if (urlHasLocationLightbox) {
            redirectToLocationPage({
              location: selectedLocation,
              originalUrl: router.asPath,
              router,
            });
          }
          setShowModal(false);
          localStorage.setItem(LIGHTBOX_APPEARED, JSON.stringify('exists'));
        } else {
          notifyError(message || SUBSCRIBER.toastrMsg);
        }

        return true;
      } else {
        setShowSpinner(false);
        notifyError(SUBSCRIBER.toastrMsg);

        return false;
      }
    } catch (error) {
      // Show error if is needed
      setShowSpinner(false);
      notifyError(SUBSCRIBER.toastrMsg);
      ErrorTrackingService.logError(`Problem with subscription: ${error}`);

      return false;
    }
  };

  const changeEmail = (event) => {
    setEmail(event.target.value);
    if (showError) setShowError(false);
  };

  const handleHoneyPotField = (event) => {
    setBotField(event.target.value);
  };
  const subscribe = async () => {
    if (botField.length > 0) {
      setShowModal(false);
      localStorage.setItem(LIGHTBOX_APPEARED, JSON.stringify('exists'));
      sendBotAlert(router);

      return;
    }

    if (validateEmail(email)) {
      const encodedEmail = encodeURIComponent(email);
      const response = await checkKickbox(encodedEmail);
      if (
        response?.data?.result === SUBSCRIBER.deliverable ||
        response?.data?.result === SUBSCRIBER.risky
      ) {
        subscribeCall(email, locationAux);
      } else {
        if (response?.data?.didYouMean) {
          setSuggestedMail(response?.data?.didYouMean);
        }
        if (
          response?.data?.result === SUBSCRIBER.undeliverable ||
          response?.data?.result === SUBSCRIBER.unknown
        ) {
          setShowKickboxError(true);
        }
      }
    } else {
      setShowError(true);
    }
  };

  // To refactor, business logic mixed with styling
  const componentClass = classNames(
    `subscribeModal-container subscriber-wrapper`,
    {
      'green-input': validateEmail(email),
      'grey-input': !fieldonfocus && !validateEmail(email),
      'red-input': !validateEmail(email) && fieldonfocus,
    },
  );

  return (
    <>
      <div className={componentClass}>
        {showSpinner && <Spinner />}
        <div className="form-group">
          <div className="header-bar row">
            <div className="logo-container col-8">
              <HeaderLogo align="left" both height="auto" width="100px" />
            </div>

            {isLightBox && (
              <SubscriberButtons
                goToLogin={goToLogin}
                handleCloseButton={handleCloseButton}
                isAuthenticated={isAuthenticated}
                isBadConnection={isBadConnection}
                isMobile={isMobile}
                showCloseIcon={showCloseIcon}
              />
            )}
          </div>
          {Boolean(subTitle) && (
            <p className="subtitle" data-testid={SUBTITLE_TEXT}>
              {subTitle}
            </p>
          )}
          {isLightBox && (
            <p className="mobile-text center-align visible-xs">
              {SUBSCRIBER.saveEightyWhereYouLive}
            </p>
          )}
          {showError && (
            <div
              className="alert alert__error animate--collapse-toggle animate"
              data-testid={ERROR_TEXT}
            >
              {SUBSCRIBER.subscriptionEmailIsRequired}
            </div>
          )}
          {showKickboxError && (
            <div
              className="alert alert__error animate--collapse-toggle animate"
              data-testid={ERROR_TEXT}
            >
              {SUBSCRIBER.kickboxFailedValidation}
            </div>
          )}
          <div className="subscribe-dropdown-container">
            <BareSelect
              ariaLabel="subscribe-dropdown"
              dataTestId={LOCATION_SELECT}
              dataqa="selectLocation"
              extraClasses="subscribe-dropdown"
              name="subscribe-dropdown"
              onChange={(event) => onChangeAction(event.target.value)}
              options={updatedList}
              value={locationAux}
            />

            <Icon
              color={theme.colors.primary}
              faIcon={faMapMarkerAlt}
              size="24px"
            />
          </div>

          <p className="center-align">{SUBSCRIBER.andCaps}</p>

          {isLightBox && !isAuthenticated && (
            <div
              className="subscribe-form__google-sign-in-container"
              data-testid={GOOGLE_BUTTON}
            >
              <LoginGoogle
                isBadConnection
                subscriberPage
                title={SIGN_UP_WITH_GOOGLE}
              />

              <TextDevider />
            </div>
          )}

          <Element name={EMAIL_INPUT_SCROLL_TO_ID} />

          <div className="email-input-container">
            <Input
              onBlur={() => setOnFocus(false)}
              onChange={changeEmail}
              onFocus={() => {
                setOnFocus(true);
                if (isLightBox) {
                  try {
                    scroller.scrollTo(EMAIL_INPUT_SCROLL_TO_ID, {
                      containerId: MODALS.lightbox,
                      delay: 100,
                      duration: 200,
                      offset: -10,
                      smooth: true,
                    });
                  } catch (error) {
                    console.warn(error);
                    ErrorTrackingService.logError(error);
                  }
                }
              }}
            />

            {/* Honey pot field */}
            <label className="text-label" htmlFor="input-container">
              {SUBSCRIBER.leaveBlank}
            </label>
            <input
              aria-label={SUBSCRIBER.leaveBlank}
              autoComplete="off"
              className="input-container"
              onChange={handleHoneyPotField}
              type="text"
            />

            <Icon
              color={theme.colors.primary}
              faIcon={faEnvelope}
              size="24px"
            />
          </div>

          {suggestedMail.length > 0 && (
            <Message
              iconPosition="left"
              message={SUBSCRIBER.didYouMean + ' ' + suggestedMail}
            />
          )}
          <div className="justify legal-text">
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: isLightBox
                  ? SUBSCRIBER.lightboxAboveText
                  : SUBSCRIBER.ppcSignUp,
              }}
            />
          </div>
          <Button
            className="submit"
            dataTestId={SUBMIT_BUTTON}
            onClick={subscribe}
            text={buttonText || SUBSCRIBER.goToDeals}
          />
          {isLightBox && (
            <div className="justify legal-text" style={{ marginTop: '10px' }}>
              <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: SUBSCRIBER.lightboxBelowText,
                }}
              />
            </div>
          )}
        </div>
      </div>
      {getSubscriberStyle(theme)}
    </>
  );
};

Subscriber.propTypes = {
  buttonText: PropTypes.string,
  defaultLocation: PropTypes.string,
  isAuthenticated: PropTypes.bool,
  isBadConnection: PropTypes.bool,
  isLightBox: PropTypes.bool,
  isLocation: PropTypes.bool,
  list: PropTypes.array.isRequired,
  redirectUrl: PropTypes.string,
  setShowModal: PropTypes.func,
  showCloseIcon: PropTypes.bool,
  subTitle: PropTypes.string,
};
